import { render, staticRenderFns } from "./ziYangDataViewNew.vue?vue&type=template&id=47d72f6d&scoped=true&"
import script from "./ziYangDataViewNew.vue?vue&type=script&lang=ts&"
export * from "./ziYangDataViewNew.vue?vue&type=script&lang=ts&"
import style0 from "./ziYangDataViewNew.vue?vue&type=style&index=0&id=47d72f6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d72f6d",
  null
  
)

export default component.exports